class ActivationForm {
  constructor() {
    this.activationCode = '';
    this.username = '';
    this.confirmUsername = '';
    this.password = '';
    this.confirmPassword = '';
    this.activationCode = '';
    this.loadingMessage = 'Loading, please wait...';
    this.error = '';
    this.errorUsername = '';
    this.errorUsernameExist = '';
    this.errorPassword = '';
    this.errorTransPass = '';
    this.errorMessage = '';
    this.success = '';
    this.successMessage = '';
  }

  toPayload() {
    return {
      activation: {
        password: {
          first: this.password,
          second: this.confirmPassword,
        },
        username: {
          first: this.username,
          second: this.confirmUsername,
        }
      },
      activationCode: this.activationCode
    };
  }
};

export default ActivationForm;



// WEBPACK FOOTER //
// ./client/app/pages/activation/model/form.model.js